module.exports = __webpack_public_path__ + "img/stand_xiaoman_1.24fd8408.jpg";